mutation PurchaseOrderUploadDocument(
  $document: DocumentUploadInput!
  $purchaseOrderId: UUID!
) {
  purchaseOrderUploadDocument(
    document: $document
    purchaseOrderId: $purchaseOrderId
  ) {
    uploadLink
    document {
      _documentFileId
      purchaseOrderDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
    }
  }
}
